module.exports = __webpack_public_path__ + "img/babiy.004b6989.png";